import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Brand01 from "web/assets/images/BrandsLogo/brand01.png";
import Brand02 from "web/assets/images/BrandsLogo/paltech.png";
import Brand03 from "web/assets/images/BrandsLogo/brand03.png";
import Brand04 from "web/assets/images/BrandsLogo/brand04.png";
import Brand06 from "web/assets/images/BrandsLogo/brand06.png";
import Brand07 from "web/assets/images/BrandsLogo/brand07.png";
import Brand08 from "web/assets/images/BrandsLogo/brand08.png";
import Brand09 from "web/assets/images/BrandsLogo/brand09.png";
import Brand11 from "web/assets/images/BrandsLogo/brand11.png";
import Brand12 from "web/assets/images/BrandsLogo/brand12.png";
import Brand13 from "web/assets/images/BrandsLogo/brand13.png";
import Brand14 from "web/assets/images/BrandsLogo/brand14.png";
import Brand15 from "web/assets/images/BrandsLogo/brand15.png";
import Brand16 from "web/assets/images/BrandsLogo/brand16.png";
import Brand17 from "web/assets/images/BrandsLogo/brand17.png";
import Brand18 from "web/assets/images/BrandsLogo/brand18.png";
import Brand19 from "web/assets/images/BrandsLogo/brand19.png";
import Brand20 from "web/assets/images/BrandsLogo/brand20.png";
import { Tooltip } from "@material-ui/core";
import "./index.override.css";

const brandImagesData = [
  {
    imgUrl: Brand01,
    brandTitle: " C&L Wood Products",
    brandInfo:
      "In business since 1975, C&L Wood Products is an experienced provider of quality pallets, skids, mulch and other wood products. Operating out of its 60-acre location in Hartselle, Alabama, C&L manufacturers some 40,000 pallets and refurbished recycles and produces over 3,500 cubic yards of solid wood waste per week for recycling into other products. The company’s premium hardwood mulch is widely used by nurseries, landscape supply centers and landscape contractors.",
  },
  {
    imgUrl: Brand02,
    brandTitle: "Paltech Enterprises",
    brandInfo:
      "Paltech Enterprises, Inc. is among the nation’s largest providers of new and recycled pallets and crates across the Midwest. With 8 locations the company’s operations service Illinois, Indiana, Michigan, Wisconsin, Iowa, Missouri, Arkansas and Oklahoma. Products include customer crates, recycled wood pallets, new wood pallets, plastic pallets, corrugated pallets, custom cut wood, and mulch products. Paltech specializes in deploying for its customers a Total Pallet Management program.",
  },
  {
    imgUrl: Brand03,
    brandTitle: "California Pallet",
    brandInfo:
      "Serving Northern California for over 20 years, local family-owned California Pallet operates five depots that provide full-scope pallet management. It maintains a substantial inventory of new and used pallets, complemented by free pallet delivery services, pallet inventory management; and recovery, recycling and pallet repairs, including heat treatment. Onsite refurbishing and repair, at either a company depot or customer location, enable shippers to extend pallet live and maximize their pallet investments",
  },
  {
    imgUrl: Brand04,
    brandTitle: "Chicago Pallet",
    brandInfo:
      "Chicago Pallet is a complete pallet management company founded in the Chicago area in 1989. It is a leader in the manufacture, repair and sales of pallets with a focus on sustainability. The company provides new pallets based on standard sizes, will build special sizes based on customer specifications, handles recycled pallets and refurbishing, and provides pallet distribution for Chicago area customers.",
  },
  {
    imgUrl: Brand06,
    brandTitle: "Cromey Pallet Corp.",
    brandInfo:
      "Cromey Pallets is based in Rochester New York providing a variety of supply, distribution, repair and recovery services for commercial and industrial pallets and skids, as well as pallet recycling. Its operations span Rochester NY & surrounding areas, providing superior customer service while keeping safety in the highest regard and being good stewards of the community.",
  },
  {
    imgUrl: Brand07,
    brandTitle: "Cutler Brothers",
    brandInfo:
      "Cutler Bros., based adjacent to New York City in Fairview New Jersey, is a leading vertically integrated wooden pallet manufacturer and recycler, has been providing innovative solutions to a diverse and demanding customer base for over four generations. Established in 1875, Cutler Brothers has grown from a local wooden crating and boxing business to one of the largest pallet manufacturers and distributors in the Northeast.",
  },
  {
    imgUrl: Brand08,
    brandTitle: "Fricks Pallet Company",
    brandInfo:
      "Fort Worth, TX-based Fricks Pallet Company specializes in custom pallet production for the greater North Texas market. A full service company and recycler, Fricks offers both pallet purchasing and pallet distribution solutions to enhance customers operations. Fricks offers new pallets, both A and B grade recycled, combo pallets, performs repair and recycling, and builds custom pallets to spec. It is one of the only companies in the DFW Metroplex area that has its own heat-treating facility on site meeting the IPPC standard. Fricks focuses on excellent quality and service and being a true partner to their customers.",
  },
  {
    imgUrl: Brand09,
    brandTitle: "John Rock",
    brandInfo:
      "John Rock Inc. is one of America’s premier pallet manufacturers and among the largest single-location manufacturer of pallets and crates in the United States. Its 300,000 sq. ft. Coatesville, PA facility has thirteen automated nailing machines and seven heat treating kilns capable of producing in excess of 120,000 pallets a week and 24 truckloads per day. The company treats between 12,000-16,000 pallets a day.",
  },
  {
    imgUrl: Brand11,
    brandTitle: "McVantage Pallet",
    brandInfo:
      "Nashville, TN and Tuscumbia, AL based McVantage Pallet Group specializes in the manufacture of wooden products including pallets, pallet lumber, and tropical hardwood products. The U.S. based companies supply pallet lumber and dunnage as well as a full line of wooden packaging products ranging from new, recycled, and “combo” pallets to custom crates, boxes, and more. It is the leading manufacturer of packaging products in the Mid-South, providing wooden packaging and lumber sourcing as well as brokerage services and has international operations manufacturing tropical hardwoods products.",
  },
  {
    imgUrl: Brand12,
    brandTitle: "Monison Pallets",
    brandInfo:
      "Monison Pallets launched into the pallet business in Florida in 1983. Since then, it has grown to be one of the state’s largest and most successful pallet distributors. A family owned company, it operates facilities in Miami, West Palm Beach, Haines City, Jacksonville and Graceville, providing standard sized pallets at different grades, heat treatment services, pallet repair and pallet removal/recovery and recycling. We provide the standard size pallets at different grades as well as other sizes, and offers Heat Treatment Services, pallet repair programs, and recovery and recycling service",
  },
  {
    imgUrl: Brand13,
    brandTitle: "Mortimer Pallet",
    brandInfo:
      "Smithfield, UT-based Mortimer Pallet has been a premier supplier of both new and used pallets since 1998. A family-owned business, Mortimer’s service area incorporates Utah, Wyoming and Idaho. Its product line includes new and recycled pallets, heat treated and custom pallet manufacture, as well as pallet recovery, refurbishing and recycling. The company prides itself on a commitment to quality customer service and efficient on-time delivery of pallets.",
  },
  {
    imgUrl: Brand14,
    brandTitle: "Pallet Recycle of Alabama",
    brandInfo:
      "Pallet Recycle, founded in 1987 and based in Lakeland Florida, has earned a reputation as a low cost, high quality and reliable partner to the shippers industry-wide requiring superior pallet solutions. With a 40-acre site and one of the largest inventories in the Southeast, the company manages all grades of pallets delivered from more than 30 repair stations. Its culture ensures excellent quality through reliability, workmanship and customer satisfaction.",
  },
  {
    imgUrl: Brand15,
    brandTitle: "Pallet Solutions",
    brandInfo:
      "Greer, SC-based Pallet Solutions offers a wide variety of pallet recycling solutions, concentrating on the recycling of wood packaging products. The company provides a single vendor approach for helping clients maintain pallet supply while achieving zero landfill status. It also offers new and recycled products, and custom-built products as well as integrated service packages enable complete end-to-end pallet control.",
  },
  {
    imgUrl: Brand16,
    brandTitle: "Petro Pallets",
    brandInfo:
      "Petro Pallet is a leading full-service, family owned / operated Pallet Company based in Monmouth Junction New Jersey. Our operations team has over 40 years of combined industry experience and we pride ourselves of tailoring our services to each of our client’s specific needs. Our services consist of collection, repair services, custom sizing, pallet scrap removal, and heat treatment.  We also purchase small and large quantities of standard 48x40 4way pallets and other sizes. We’re here to help – give us a call!",
  },
  {
    imgUrl: Brand17,
    brandTitle: "R&E Pallets",
    brandInfo:
      "With the encouragement and support of his father, in 2006 Salvador Gomez started pallet recycler R&E Pallets Inc. Salvador is president of R&E Pallets; his father Isaias is vice president. In just sixteen years, R&E Pallets has substantially grown, selling about 35,000 pallets a week, in which 60% are recycled and 40% new. R&E Pallets is a family owned business based in Michigan City, Indiana and now with a second location in South Chicago Heights Illinois.",
  },
  {
    imgUrl: Brand18,
    brandTitle: "R & R Pallet",
    brandInfo:
      "Garden City, KS-based Tri-Pac North America is a full-service pallet supply chain and logistics company with over 500 local affiliates strategically located across the U.S., Canada and Mexico. With decades of industry experience, the company provides pallet solutions that streamline business while cutting costs and increasing green revenue. Tri-Pac has innovative recycling approaches, and Total Pallet Management onsite sorting, repairing, loading services suitable for any size operation.  Maintaining an extensive inventory of new, used and reman pallets, Tri-Pac North America also builds and delivers new pallets designed and engineered to exact customer specifications.",
  },
  {
    imgUrl: Brand19,
    brandTitle: "San Fernando Valley Pallet",
    brandInfo:
      "San Fernando Valley Pallet (SFVP) in Chatsworth is one of Southern California’s largest distributors of white wood pallets. A family owned business, it is the resource relied upon by hundreds of customers for reliable and competitive pallet pricing and on time delivery as well as recovery and repair services, and new pallet construction. It’s led by founders Jorge and Susie Eroza, and their son, Director of Business Development George Eroza. SFVP is one of many companies that participated in the launch of Pallet Trader, supporting innovation in the industry.",
  },
  {
    imgUrl: Brand20,
    brandTitle: "Tri-Pac North America",
    brandInfo:
      "Garden City, KS-based Tri-Pac North America is a full-service pallet supply chain and logistics company with over 500 local affiliates strategically located across the U.S., Canada and Mexico. With decades of industry experience, the company provides pallet solutions that streamline business while cutting costs and increasing green revenue. Tri-Pac has innovative recycling approaches, and Total Pallet Management onsite sorting, repairing, loading services suitable for any size operation.  Maintaining an extensive inventory of new, used and reman pallets, Tri-Pac North America also builds and delivers new pallets designed and engineered to exact customer specifications.",
  },
];

const TooltipData = (props) => {
  return (
    <div className="px-3 tool-tip-div rounded tool-tip-container">
      <div className="d-flex flex-column align-items-center mb-1">
        <p className="font-weight-bold para">{props.brandTitle}</p>
        <p className="brand-info brand-info-para">{props.brandInfo}</p>
      </div>
    </div>
  );
};

const BrandsLogo = () => {
  let history = useHistory();

  return (
    <Container>
      {brandImagesData.map((item) => (
        <div key={item.brandTitle}>
          <Tooltip
            // enterTouchDelay={0}
            // leaveTouchDelay={12000}
            enterTouchDelay={0}
            leaveTouchDelay={3000}
            arrow
            title={
              <TooltipData
                brandTitle={item.brandTitle}
                brandInfo={item.brandInfo}
              />
            }
            classes={{
              tooltip: "custom-tooltip",
              arrow: "custom-arrow",
            }}
          >
            <img src={item.imgUrl} alt="brands" />
          </Tooltip>
        </div>
      ))}
    </Container>
  );
};

export default BrandsLogo;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 80px;
  > div {
    width: 25%;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    max-width: 100%;    
    width: 90%;
    aspect-ratio: 3/2;
    object-fit: contain;
  }
  @media (max-width: 767px) {
    > div {
      width: 100%;
      img {
        max-width: 120px;
      }
    }
  }
`;
